import { Box, Header } from '@fhs-legacy/universal-components';

export const InformationTitle = Header.withConfig({
  variant: 'headerThree',
});

export const NutritionInformationWrapper = Box.withConfig({
  marginTop: 4,
  paddingX: 4,
});
